module.exports = __webpack_public_path__ + "img/09攤位活動.4112d54d.png";